<div class="account" [matMenuTriggerFor]="profile" [title]="(email$ | async) || ''">
    <mat-icon class="account-icon">account_circle</mat-icon>
    <span class="account-name">{{ (email$ | async) || (shortName$ | async) }}</span>
    <mat-icon class="account-caret">arrow_drop_down</mat-icon>

    <mat-menu #profile="matMenu">
        <div class="account-menu-head" *ngIf="email$ | async as email">
            <span class="account-menu-email">{{ email }}</span>
        </div>
        <button mat-menu-item [routerLink]="['/admin/settings']">
            <mat-icon>settings</mat-icon> Settings
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon> Logout
        </button>
    </mat-menu>
</div>
